import commonRouteNames from '@shared/constants/common-route-name'

export default {
  home: commonRouteNames.home,
  authCheck: commonRouteNames.authCheck,
  widget: 'widget',
  conversation: 'conversation',
}
